import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

window.__APP_VERSION__ = '2.0.1';

// Captura global del evento de instalación PWA: Chrome lo dispara apenas carga la página,
// mucho ANTES de que monten las apps lazy (/app/*). Sin esto, cuando usePwaInstall empieza
// a escuchar el evento ya pasó y el botón "Instalar app" nunca aparece en el celular.
window.__pwaDeferredPrompt = null;
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  window.__pwaDeferredPrompt = e;
});
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);

reportWebVitals();